export const ROUTE_LIMIT_DEPARTMENT_GROUP_ID_QUERY_PARAM = 'route-limit-department-group-id'
export const MAX_ROUTES_FOR_DEPARTMENT_GROUP = 250
